<template>
  <div>
    <!-- Mensaje de advertencia si el nivel hijo no existe -->
    <b-alert 
      v-if="isFromTemporaryLocation && !childLevelExists" 
      variant="warning" 
      show 
      class="mb-3 text-center"
    >
      <i class="fa fa-exclamation-triangle mr-2"></i>
      <strong>Advertencia:</strong> Para poder aprobar esta ubicación, primero debe crear el nivel <b>{{ parentLevel + 1 }}</b> en la configuración de niveles de ubicación.
    </b-alert>

    <!-- Información de jerarquía cuando se crea ubicación hija -->
    <div v-if="isChildLocation" class="mb-4 p-3 bg-light rounded border">
      <div class="mb-2">
        <strong>Jerarquía:</strong>
        <span class="text-primary ml-2">{{ selectedUbicacion._parentHierarchy }}</span>
      </div>     
    </div>
    
    <form form method="post" data-vv-scope="crear">
      <b-row class="mt-4">
        <!-- Descripción de la ubicación -->
        <b-col sm="6">
          <b-form-group>
            <label for="descripcion"
              >Descripción Ubicación <span class="text-danger">*</span></label
            >
            <b-form-input
              ref="descripcionInput"
              id="descripcion"
              size="sm"
              type="text"
              name="descripcion"
              class="text-uppercase"
              v-model="selectedUbicacion.description"
              data-vv-as=" "
              v-validate="'required'"
            >
            </b-form-input>
            <span class="text-danger span-error small">
              {{ errors.first("crear.descripcion") }}
            </span>
          </b-form-group>
        </b-col>

        <!-- Asignar País -->
        <b-col sm="6">
            <b-form-group>
                <label for="company_country_id">Asignar País</label><br />
                <el-select id="company_country_id" name="company_country_id" v-model="selectedUbicacion.company_country_id" data-vv-as=" " size="sm" clearable class="select-with-flag">
                <template slot="prefix" v-if="selectedCountry">
                    <div class="flag-prefix-container">
                        <img 
                          :src="`https://flagsapi.com/${selectedCountry.country.code.toUpperCase()}/flat/64.png`" 
                          class="flag-img-select"
                        >
                    </div>
                </template>
                <el-option
                    v-for="countryCompany in countriesCompany"
                    :label="`${countryCompany.country.name} - [${countryCompany.country.code}]`"
                    :value="countryCompany.id"
                    :key="countryCompany.id"
                >
                    <div class="d-flex align-items-center">
                        <img 
                          :src="`https://flagsapi.com/${countryCompany.country.code.toUpperCase()}/flat/64.png`" 
                          class="mr-2 flag-img-option"
                        >
                        <span>{{ countryCompany.country.name }} - [{{ countryCompany.country.code }}]</span>
                    </div>
                </el-option>
                </el-select>
            </b-form-group>
        </b-col>

      </b-row>

      <b-row>
        <b-col sm="6" v-if="countriesWithEnterprises.length">
          <b-form-group>
            <label for="id_nivel">País</label><br />
            <el-select
              id="country"
              name="country"
              v-model="country_id"
              data-vv-as=" "
              size="sm"
              clearable
            >
              <el-option
                v-for="country in countriesWithEnterprises"
                :label="country.name"
                :value="country.id"
                :key="country.id"
              />
            </el-select>
          </b-form-group>
        </b-col>

        <b-col sm="6" v-if="countriesWithEnterprises.length && enterprises.length">
          <b-form-group>
            <label for="id_nivel">Enterprise</label><br />
            <el-select
              id="enterprise"
              name="enterprise"
              v-model="enterprise_id"
              data-vv-as=" "
              size="sm"
              v-validate="this.country_id ? 'required' : ''"
              clearable
            >
              <el-option
                v-for="enterprise in enterprises"
                :label="enterprise.name"
                :value="enterprise.id"
                :key="enterprise.id"
              />
            </el-select>
            <span class="text-danger span-error small">
              {{ errors.first("crear.enterprise") }}
            </span>
          </b-form-group>
        </b-col>

        <b-col sm="6" v-if="groups.length && enterprises.length">
          <b-form-group>
            <label for="id_nivel">Grupo</label><br />
            <el-select
              id="group"
              name="group"
              v-model="group_id"
              data-vv-as=" "
              size="sm"
              clearable
              v-validate="this.enterprise_id ? 'required' : ''"
            >
              <el-option
                v-for="group in groups"
                :label="group.name"
                :value="group.id"
                :key="group.id"
              />
            </el-select>
            <span class="text-danger span-error small">
                {{ errors.first("crear.group") }}
              </span>
          </b-form-group>
        </b-col>

        <b-col sm="6" v-if="groups.length && businesses.length">
          <b-form-group>
            <label for="id_nivel">Businesses</label><br />
            <el-select
              id="business"
              name="business"
              v-model="business_id"
              data-vv-as=" "
              size="sm"
              clearable
              v-validate="this.group_id ? 'required' : ''"
            >
              <el-option
                v-for="business in businesses"
                :label="business.name"
                :value="business.id"
                :key="business.id"
              />
            </el-select>
            <span class="text-danger span-error small">
                {{ errors.first("crear.business") }}
              </span>
          </b-form-group>
        </b-col>

        <b-col sm="6" v-if="subBusinesses.length && businesses.length">
          <b-form-group>
            <label for="id_nivel">Sub Businesses</label><br />
            <el-select
              id="sub_business"
              name="sub_business"
              v-model="selectedUbicacion.slq_business_sub_business_id"
              data-vv-as=" "
              size="sm"
              clearable
              v-validate="this.business_id ? 'required' : ''"
            >
              <el-option
                v-for="sub_business in subBusinesses"
                :label="sub_business.name"
                :value="sub_business.id"
                :key="sub_business.id"
              />
            </el-select>
            <span class="text-danger span-error small">
                {{ errors.first("crear.sub_business") }}
              </span>
          </b-form-group>
        </b-col>
      </b-row>
    </form>
    <b-row>
      <b-col>
        <button class="btn btn-primary float-right" @click="nuevaUbicacion()">
          Guardar
        </button>
        <b-button class="btn btn-default float-right mr-2" @click="cancelar">
          Cancelar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      country_id: null,
      enterprise_id: null,
      group_id: null,
      business_id: null,
    };
  },
  watch: {
    'modal.ver': {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            setTimeout(() => {
              if (this.$refs.descripcionInput) {
                this.$refs.descripcionInput.focus();
              }
            }, 300);
          });
        }
      },
      immediate: true
    },
    country_id: {
      handler: async function (val) {
        if (val) {
          await this.getCountryByIdAndCompanyId({
            country_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setEnterprises([]);
          this.setGroups([]);
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.enterprise_id = null;
          this.group_id = null;
          this.business_id = null;
        }
      },
      deep: true,
    },
    enterprise_id: {
      handler: async function (val) {
        if (val) {
          await this.getEnterpriseByIdAndCompanyId({
            enterprise_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setGroups([]);
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.group_id = null;
          this.business_id = null;
        }
      },
      deep: true,
    },
    group_id: {
      handler: async function (val) {
        if (val) {
          await this.getGroupByIdAndCompanyId({
            group_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.business_id = null;
        }
      },
      deep: true,
    },
    business_id: {
      handler: async function (val) {
        if (val) {
          await this.getBusinessByIdAndCompanyId({
            business_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setSubBusinesses([]);
          this.selectedUbicacion.slq_business_sub_business_id = null;
        }
      },
      deep: true,
    },
  },
  methods: {
    async verNivel() {
      this.setFiltroNivel();
      await this.listarNivel(this.$route.params.id);
    },
    async nuevaUbicacion() {
      if (!this.selectedUbicacion.parent) {
        this.selectedUbicacion.slq_location_id = null;
      }
      this.$validator.validateAll("crear").then(async (result) => {
        if (result) {
          await this.crearUbicacion(this.$route.params.id);
          this.resetSelectedUbicacion();
          this.setModal(false);
          this.setEnterprises([]);
          this.setGroups([]);
          this.setBusinesses([]);
          this.setSubBusinesses([]);
        }
      });
    },
    async cancelar() {
      this.resetSelectedUbicacion();
      this.resetOptions();
      this.setModal(false);
    },
    ...mapActions("location", [
      "crearUbicacion",
      "listLevels",
      "verListaUbicaciones",
      "listarNivelActivos",
      "crearUbicacionEmpresa",
      "arbolUbicacionesEmpresa",
    ]),
    ...mapMutations("location", [
      "setFiltro",
      "setUbicacionEmpresa",
      "setPaso",
      "setModal",
      "setEnlazarUbicacion",
      "resetSelectedUbicacion",
      "resetSelectedNivel",
      "setIdParent",
      "resetOptions",
    ]),

    ...mapActions("countries", ["getCountryByIdAndCompanyId"]),
    ...mapActions("enterprises", ["getEnterpriseByIdAndCompanyId"]),
    ...mapActions("groups", ["getGroupByIdAndCompanyId"]),
    ...mapActions("businesses", ["getBusinessByIdAndCompanyId"]),

    ...mapMutations("enterprises", ["setEnterprises"]),
    ...mapMutations("groups", ["setGroups"]),
    ...mapMutations("businesses", ["setSubBusinesses", "setBusinesses"]),
  },
  computed: {
    ...mapState("location", [
      "selectedUbicacion",
      "ubicaciones",
      "ubicacionEmpresa",
      "nivelesActivos",
      "id_ubicacion",
      "ubicacionAsig",
      "crearUbic",
      "modal",
      "errorUbic",
      "selectedNivel",
      "locationsActive",
      "moduleCreated",
    ]),
    ...mapState("countries", ["countriesWithEnterprises"]),
    ...mapState("enterprises", ["enterprises"]),
    ...mapState("groups", ["groups"]),
    ...mapState("businesses", ["businesses", "subBusinesses"]),

    // Estados del modulo Países de la empresa (variables configurable)
    ...mapState('configurableVariables', {
      countriesCompany: 'configurableVariables'
    }),

    isFromTemporaryLocation() {
      return this.moduleCreated === 'temporaryLocations';
    },
    /**
     * Detectar si se está creando una ubicación hija desde el árbol
     */
    isChildLocation() {
      return this.moduleCreated === 'childLocation' && this.selectedUbicacion._isChildLocation;
    },
    /**
     * Detectar si se está creando una ubicación raíz (nivel 1)
     */
    isRootLocation() {
      return this.moduleCreated === 'locations' && !this.selectedUbicacion._isChildLocation;
    },
    /**
     * Validar si el nivel hijo existe
     */
    childLevelExists() {
      if (!this.isFromTemporaryLocation || !this.selectedUbicacion._parentLevel) {
        return true;
      }
      if (!this.nivelesActivos || !this.nivelesActivos.data) {
        return true; 
      }
      const childLevel = this.nivelesActivos.data.find(nivel => nivel.level === this.selectedUbicacion._parentLevel + 1);
      return !!childLevel;
    },
    /**
     * Obtener el nivel padre
     */
    parentLevel() {
      return this.selectedUbicacion._parentLevel || 0;
    },

    /**
     * Obtener el país seleccionado de la lista de países de la empresa
     */
    selectedCountry() {
        if (!this.countriesCompany || !this.selectedUbicacion.company_country_id) return null;
        return this.countriesCompany.find(c => c.id === this.selectedUbicacion.company_country_id);
    }
  },
};
</script>

<style scoped>
.flag-img-select {
  height: 15px;
}

.flag-img-option {
  height: 20px;
}

.flag-prefix-container {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 5px;
}
</style>
